<template>
  <!-- 班级IEP学习 -->
  <div class="my-iep">
    <div class="head"></div>
    <div class="mock-box">
      <ul class="mack-menu">
        <li class="div-flex mb12">
          <div class="flex-label">内容</div>
        </li>
        <li class="div-flex">
          <div class="flex-value">
            <van-field v-model="model.classContent" rows="4" autosize type="textarea" class="input-textarea"
              maxlength="1000" placeholder="请输入" show-word-limit />
          </div>
        </li>
        <li class="div-flex">
          <div class="flex-label">时间段</div>
          <div class="flex-value" @click="handleShowDataTime">
            <div class="dataTime">
              <div class="dataTime-box">
                <p class="title" v-if="model.dataTime">{{ model && model.dataTime }}</p>
                <p class="desc" v-else>请选择</p>
                <i class="icon-time"></i>
              </div>
            </div>
          </div>
        </li>
        <li class="div-flex mb12">
          <div class="flex-label-no">其他</div>
        </li>
        <li class="div-flex">
          <div class="flex-value">
            <van-field v-model="model.other" rows="2" autosize type="textarea" class="input-textarea" maxlength="1000"
              placeholder="请输入" show-word-limit />
          </div>
        </li>
        <li class="div-flex flex-top" @click="handleGo('course')">
          <div class="flex-label">关联课程</div>
          <div class="flex-value">
            <ul class="associated-menu" v-if="changeCourseCon && changeCourseCon.length > 0">
              <li class="menu-li" v-for="(acc, index) in changeCourseCon" :key="index">
                <p class="as-title">{{ acc && acc.name }}</p>
                <i class="icon-del" @click.stop="handleClickDel(acc)"></i>
              </li>
            </ul>
            <template v-else>
              <span class="btn-txt btn-txt2">选择课程</span>
              <img src="@/assets/images/grade/icon-right.png" class="icon-right" alt="">
            </template>
          </div>
        </li>
        <li class="div-flex flex-top" @click="handleGo('question')">
          <div class="flex-label">
            考试题目
            <span class="label-tip" v-if="questionNum > -1">{{questionNum}}道</span>
          </div>
          <div class="flex-value">
            <span class="btn-txt">查看题目</span>
            <img src="@/assets/images/grade/icon-right.png" class="icon-right" alt="">
          </div>
        </li>
        <li class="div-flex">
          <div class="flex-label">
            最多答题次数
          </div>
          <div class="flex-value">
            <van-radio-group direction="horizontal" v-model="inspectNumRadio">
              <van-radio name="1" checked-color="#EB1700" icon-size="15px">不限</van-radio>
              <van-radio name="2" checked-color="#EB1700" icon-size="15px">
                <van-stepper v-model="model.inspectNum" />
              </van-radio>
            </van-radio-group>
          </div>
        </li>
        <addGroup ref="addGroup" :model="model" :classId="classId" :selectIds="model.groupIds" @update:selection="handleSelectionUpdate"></addGroup>
      </ul>
      <div class="confirm-btn" @click="handleAddMackConfirm">确定</div>
    </div>
    <div class="model" v-if="isModelData">
      <div class="model-data">
        <div class="model-head">
          <p class="close" @click.stop="handleModelClose">取消</p>
          <p class="head-title">自定义时间</p>
          <p class="ok" @click="confirmDataOk">确定</p>
        </div>
        <div class="model-main">
          <div class="model-top">
            <div class="main-left">
              <van-field readonly clickable name="datetimePicker" :value="cutStartTime" @focus="start" placeholder="点击选择开始时间"
                :class="showModalLeftPicker ? 'startTime' : ''" @click="handleLeftData" />
            </div>
            <span class="hen">-</span>
            <div class="main-right">
              <van-field readonly clickable name="datetimePicker" :value="cutEndTime" placeholder="点击选择结束时间"
                :class="showModalRightPicker ? 'startTime' : ''" @click="handleRightData" />
            </div>
          </div>
          <div class="model-btm">
            <van-datetime-picker v-if="showModalLeftPicker" type="datetime" ref="dateTimePicker" :min-date="minDate"
              :max-date="maxDate" @change="onDataConfirm" :filter="filter" />
            <van-datetime-picker v-else-if="showModalRightPicker" type="datetime" ref="dateTimeRightPicker"
              :min-date="minRightDate" :max-date="maxDate" @change="onDataRightConfirm" :filter="filter" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { addClassCard, editClassCard, classUserPermissions, campStudyQuestionNum, postCardDetails } from '@/api/grade'
import addGroup from './components/addGroup.vue'
import withRouteTracking from '@/utils/withRouteTracking'
import { debounce } from '@/utils/util'
const UserProfile = {
  name: 'gradeMock',
  components: {
    addGroup
  },
  data () {
    return {
      checkMockType: false,
      showDataTimePicker: false,
      minDate: new Date(),
      minRightDate: new Date(),
      maxDate: new Date(2050, 12, 31),
      uploadPost: false,
      cutStartTime: '',
      cutEndTime: '',
      mockTypeList: [],
      startTime: '',
      endTime: '',
      classId: '',
      postId: '',
      changeCourseCon: [], // 关联内容
      leftPicker: '',
      rightPicker: '',
      isModelData: false,
      showModalLeftPicker: true,
      showModalRightPicker: false,
      contentMaxLength: 1000,
      isAdmin: false,
      inspectNumRadio: '2',
      model: {
        classContent: '',
        dataTime: '',
        startTime: '',
        endTime: '',
        other: '',
        groupIds: '',
        inspectNum: 1
      },
      questionNum: -1
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  created () {
    this.classId = this.$route.query.classId || this.$route.query.areaId
    this.postId = this.$route.query.postId
    if (this.postId) {
      this.handleInit()
    }
    if (sessionStorage.getItem('addExmine')) {
      this.model = JSON.parse(`${sessionStorage.getItem('addExmine')}`)
    }
    this.classPermissions = JSON.parse(sessionStorage.getItem('classPermissions'))
    if (!(this.classPermissions && this.classPermissions.classId)) {
      this.getClassUserPermissions()
    } else {
      this.isAdmin = this.classPermissions.isAdminPermiss
    }
  },
  async mounted () {
    this.changeCourseCon = JSON.parse(sessionStorage.getItem('changeCourseCon'))
    this.handleGetQuestions()
  },
  methods: {
    handleUpdateSession() {
      sessionStorage.setItem('addExmine', JSON.stringify(this.model))
    },
    handleGetQuestions() {
      if (this.changeCourseCon && this.changeCourseCon.length > 0) {
        let params = {
          baseIds: this.changeCourseCon.map(res => res.id),
          showType: 2
        }
        campStudyQuestionNum(params).then(res => {
          this.questionNum = res.data
        })
      }
    },
    handleSelectionUpdate(ids) {
      // 子组件触发事件，更新父组件的选中集合
      this.model.groupIds = ids
    },
    handleInit() {
      postCardDetails(this.postId).then(res => {
        const data = res.data
        if (data.studyContents.length > 0) {
          data.studyContents.forEach(acc => {
            acc.name = acc.title
            acc.id = acc.baseId
          })
        }
        this.cutStartTime = this.$moment(data.startTime * 1).format('YYYY-MM-DD HH:mm')
        this.cutEndTime = this.$moment(data.endTime * 1).format('YYYY-MM-DD HH:mm')
        let endTime = this.$moment(data.endTime * 1).format('MM-DD HH:mm')
        data.dataTime = `${this.cutStartTime} ~ ${endTime}`
        this.model = data
        this.model.inspectNum ? this.inspectNumRadio = '2' : this.inspectNumRadio = '1'
        this.model.groupIds = data.postGroups.reduce((acc, item) => { if (item.isSelected) acc.push(item.id); return acc }, [])
        sessionStorage.setItem('addGradeExamine', JSON.stringify(this.model.groupIds))
        let changeAboutCon = JSON.parse(sessionStorage.getItem('changeCourseCon'))
        if (!changeAboutCon) {
          this.changeCourseCon = data.studyContents
          sessionStorage.setItem('changeCourseCon', JSON.stringify(data.studyContents))
        }
      })
    },
    getClassUserPermissions () {
      const params = {
        classId: this.classId,
        userId: this.userInfo.id
      }
      classUserPermissions(params).then(res => {
        const data = res.data
        if (this.userInfo.memberType === 1 && data.inClassList) { // 员工
          if ([1, 2].includes(data.roleType)) { // 超管，管理员可以发帖
            this.isAdmin = true
          }
        }
      })
    },
    filter (type, options) {
      if (type === 'minute') {
        return options.filter((option) => option % 15 === 0)
      }
      return options
    },
    confirmDataOk () {
      if (!this.cutStartTime) return this.$toast('开始时间不能为空')
      if (!this.cutEndTime) return this.$toast('结束时间不能为空')
      this.isModelData = false
      if (this.cutEndTime && this.cutStartTime) {
        var dateTimeArray = this.cutEndTime.split(' ') // 将字符串按空格分割成数组
        const monthDayTime = dateTimeArray[0].substring(5) + ' ' + dateTimeArray[1] // 截取月日时分部分
        this.model.dataTime = `${this.cutStartTime}~${monthDayTime}`
      }
      this.minDate = new Date(this.cutStartTime)
      if (this.cutEndTime) {
        this.handleLeftValidate()
        // this.maxDate = new Date(this.cutEndTime)
      } else {
        this.maxDate = new Date(2050, 12, 31)
      }
      this.model.startTime = this.cutStartTime
      this.model.endTime = this.cutEndTime
      this.showModalLeftPicker = true
      this.showModalRightPicker = false
    },
    // 选择开始时间
    start (e) {
      this.showModalLeftPicker = true
    },
    // 选择结束时间
    end (e) {
      this.showModalRightPicker = true
    },
    handleShowDataTime () {
      this.isModelData = true
      this.showModalLeftPicker = true
      this.showModalRightPicker = false
      this.cutStartTime = this.cutStartTime ? this.$moment(this.cutStartTime).format('YYYY-MM-DD HH:mm') : this.$moment(new Date()).format('YYYY-MM-DD HH:mm')
      this.cutStartTime = this.cutStartTime
    },
    handleLeftData () {
      this.minDate = new Date()
      if (this.cutEndTime) {
        this.handleLeftValidate()
        // this.maxDate = new Date(this.cutEndTime)
      } else {
        this.maxDate = new Date(2050, 12, 31)
      }
      this.showModalLeftPicker = true
      this.showModalRightPicker = false
    },
    handleRightData () {
      // this.minRightDate = new Date(this.cutStartTime)
      this.minRightDate = new Date()
      this.maxDate = new Date(2050, 12, 31)
      this.showModalLeftPicker = false
      this.showModalRightPicker = true
    },
    onDataConfirm (value, index) {
      const selectedDateTime = this.$refs.dateTimePicker.getPicker().getValues()
      this.cutStartTime = selectedDateTime.slice(0, 3).join('-') + ' ' + selectedDateTime.slice(3, 5).join(':')
      this.handleLeftValidate()
      this.handleRightValidate()
      this.$forceUpdate()
    },
    onDataRightConfirm (value) {
      const selectedDateTime = this.$refs.dateTimeRightPicker.getPicker().getValues()
      this.cutEndTime = selectedDateTime.slice(0, 3).join('-') + ' ' + selectedDateTime.slice(3, 5).join(':')
      this.$forceUpdate()
      this.$forceUpdate()
      this.handleRightValidate()
    },
    handleLeftValidate () {
      if (Date.parse(this.cutStartTime) > Date.parse(this.cutEndTime)) {
        return this.$toast('开始时间不能大于结束时间')
      }
    },
    handleRightValidate () {
      if (Date.parse(this.cutEndTime) < Date.parse(this.cutStartTime)) {
        return this.$toast('结束时间必须大于开始时间')
      }
    },
    handleModelClose () {
      this.isModelData = false
      this.showModalLeftPicker = false
      this.showModalRightPicker = false
      this.cutEndTime = ''
      this.cutStartTime = ''
    },

    handleGo (type) {
      let path = ''
      let query = {}
      this.handleUpdateSession()
      switch (type) {
        case 'question':
          path = '/gradeQuestionPreview'
          query = {
            classId: this.classId,
          }
          break

        case 'course':
          path = '/examineAboutContent'
          query = {
            classId: this.classId,
          }
          break

        default:
          break
      }
      this.$router.push({
        path,
        query
      })
    },
    // 删除关联内容
    handleClickDel (item) {
      this.changeCourseCon = this.changeCourseCon.filter(res => res.id !== item.id)
      sessionStorage.setItem('changeCourseCon', JSON.stringify(this.changeCourseCon))
    },
    getPlainTextLen (richText) {
      return richText
        .replace(/<[^>]+>/g, '')
        .replace(/ |\n|\r\n|&nbsp;|&ensp;/g, '')
        .replace(/[a-zA-Z]&#7([6-7][0-9]);/g, ' ')
        .replace(/&([a-z]{2,5}|#[0-9]{1,6});/g, ' ')
        .length
    },
    // 提交帖子
    handleAddMackConfirm: debounce(async function () {
      if (!this.model.classContent) {
        this.$toast('请输入内容')
        return
      }
      if (this.getPlainTextLen(this.model.classContent) > this.contentMaxLength) {
        this.$toast('内容字数超过1000！')
        return
      }
      if (!this.model.startTime) {
        this.$toast('请选择时间段')
        return
      }
      if (!this.model.endTime) {
        this.$toast('请选择时间段')
        return
      }
      if (Date.parse(this.model.startTime) > Date.parse(this.model.endTime)) {
        return this.$toast('开始时间不能大于结束时间')
      }
      if (this.getPlainTextLen(this.model.other) > this.contentMaxLength) {
        this.$toast('字数超过1000！')
        return
      }
      if (!this.changeCourseCon || (this.changeCourseCon && this.changeCourseCon.length <= 0)) {
        this.$toast('请选择关联课程')
        return
      }
      if (this.uploadPost) return
      if (!this.isAdmin) {
        this.$toast('暂无权限发布考试帖子！')
        this.$router.push({
          path: `/gradeHomePage?classId=${this.classId}`
        })
        return
      }
      this.uploadPost = true
      const { classContent, other, groupIds, inspectNum } = this.model
      let params = {
        id: this.postId,
        areaId: this.classId,
        type: '9',
        userId: this.userInfo.id,
        classContent,
        startTime: Date.parse(this.model.startTime),
        endTime: Date.parse(this.model.endTime),
        other,
        workDataAddROS: this.changeCourseCon.length > 0 ? this.changeCourseCon.map(item => {
          return {
            'userId': this.userInfo.id,
            'title': item.name,
            'type': 2,
            'baseId': item.id,
            'cover': item.coverMaterialUrl
          }
        }) : [],
        kind: '4',
        // 5班级发帖6iep课程7线上答疑8模拟器练习9考试
        postType: '9',
        groupIds: groupIds && groupIds.length > 0 ? groupIds : [],
        inspectNum: this.inspectNumRadio === '1' ? 0 : inspectNum || 1
      }

      if (params.id) {
        editClassCard(params).then(res => {
          setTimeout(() => {
            this.$router.push({
              path: `/gradeHomePage?classId=${this.classId}`
            })
          }, 1500)
          sessionStorage.removeItem('addExmine')
          sessionStorage.removeItem('addGradeExamine')
          this.$toast('发布成功')
        }).catch((err) => {
          this.$toast(err.msg)
          this.uploadPost = false
        })
      } else {
        delete params.id
        addClassCard(params).then(res => {
          localStorage.removeItem('addIEPCon')
          localStorage.removeItem('changeCourseCon')
          setTimeout(() => {
            this.$router.push({
              path: `/gradeHomePage?classId=${this.classId}`
            })
          }, 1500)
          sessionStorage.removeItem('addExmine')
          sessionStorage.removeItem('addGradeExamine')
          this.$toast('发布成功')
        }).catch((err) => {
          this.$toast(err.msg)
          this.uploadPost = false
        })
      }
    }, 500),
    handleAboutConSet () {
      let obj = {}
      let list = []
      this.changeCourseCon.filter(acc => {
        obj = {
          userId: this.userInfo.id,
          title: acc.title,
          type: acc.type,
          baseId: acc.baseId,
          cover: acc.coverUrl,
        }
        list.push(obj)
      })
      return list
    },
  },

}
export default withRouteTracking(UserProfile)
</script>

<style scoped lang="less">
.my-iep {
  width: 100%;
  height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  z-index: 999;
  background-color: #F9F8F7;
  padding: 22px 10px 20px;
  box-sizing: border-box;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    width: 100%;
    height: 146px;
    background-image: url('../../assets/images/grade/iep-bg.png');
    background-repeat: no-repeat;
    background-size: 100%;
  }

  .head {
    background: url('../../assets/images/grade/examine-title.png') no-repeat center center / 100% 100%;
    width: 83px;
    height: 21px;
    position: relative;
    z-index: 66;
    margin-bottom: 14px;
  }

  .mock-box {
    position: relative;
    background: #fff;
    // background: linear-gradient( 180deg, rgba(255,91,12,0.1) 10%, rgba(255,91,12,0) 100%), #FFFFFF;
    border-radius: 12px;
    border: 1px solid #FFFFFF;
    width: 100%;
    flex: 1;
    position: relative;
    height: calc(100vh - 80px);

    .mack-menu {
      position: relative;
      z-index: 2;
      margin: 0;
      padding: 24px 10px 40px;
      height: calc(100% - 35px - 82px);
      position: relative;
      display: flex;
      flex-direction: column;
      overflow-y: auto;

      .div-flex {
        display: flex;
        align-items: center;
        justify-content: space-between;
        // height: 42px;
        box-sizing: border-box;
        margin-bottom: 30px;
      }

      .mb12 {
        margin-bottom: 12px;
      }

      .mb0 {
        margin-bottom: 0;
      }

      .flex-top {
        align-items: flex-start;
      }

      .flex-label,
      /deep/ .field-color-request .van-field__label,
      .label-txt {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.6);
        line-height: 20px;
        padding-left: 8px;
        box-sizing: border-box;
        position: relative;

        &::before {
          content: "*";
          font-size: 14px;
          color: #FF3C3C;
          width: 12px;
          line-height: 20px;
          position: absolute;
          top: 3px;
          left: 0;
          box-sizing: border-box;
        }
      }

      .label-tip {
        margin-left: 4px;
        font-weight: 500;
        font-size: 14px;
        color: #000000;
        font-family: Source Han Sans CN, Source Han Sans CN;
      }

      .flex-label-no {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.6);
        line-height: 20px;
        padding-left: 8px;
        box-sizing: border-box;
        position: relative;
      }

      /deep/ .van-cell {
        background: none !important;
        padding: 10px 0 !important;
      }

      /deep/ .van-cell::after {
        border-bottom: none !important;
      }

      /deep/ .van-field__control:read-only {
        text-align: right !important;
      }

      .flex-value {
        flex: 1;
        text-align: right;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        .btn-txt {
          color: #EB1700;
          font-size: 14px;
          font-weight: 500;
          margin-right: 10px;
          &.btn-txt2 {
            color: #323233;
          }
        }

        .icon-right {
          width: 9px;
          display: block;
        }

        .input-title {
          border: none;
          text-align: right;
          width: 85%;
          flex: 1;
        }

        .dataTime {
          flex: 1;
          text-align: right;
          align-items: center;
          justify-content: end;

          .dataTime-box {
            text-align: right;
            display: flex;
            align-items: center;
            justify-content: end;

            .desc {
              color: #AEAEAE;
              font-weight: 500;
              font-size: 14px;
              flex: 1;
            }

            .title {
              color: #323233;
              font-weight: 500;
              font-size: 14px;
              flex: 1;
            }
          }
        }

        .desc {
          color: #AEAEAE;
          font-weight: 500;
          font-size: 14px;
        }

        .input-textarea {
          overflow-y: scroll !important;
          background: #F9F9F9 !important;
          padding: 10px !important;
          border-radius: 4px;
        }

        .icon-down {
          background: url('../../assets/images/grade/drop-down.png') no-repeat center center / 100% 100%;
          width: 11px;
          height: 6px;
          display: inline-block;
          margin-left: 4px;
        }

        .icon-time {
          background: url('../../assets/images/grade/icon-time.png') no-repeat center center / 100% 100%;
          width: 15px;
          height: 14px;
          display: inline-block;
          margin-left: 4px;
        }

        .associated-menu {
          margin: 0;
          text-align: right;

          .menu-li {
            display: flex;
            align-items: center;
            text-align: right;

            .as-title {
              font-size: 14px;
              color: #EB1700;
              white-space: nowrap;
              text-align: right;
              width: 180px;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .icon-del {
              background: url('../../assets/images/grade/icon-del.png') no-repeat center center / 100% 100%;
              width: 16px;
              height: 16px;
              margin-left: 8px;
            }
          }

        }
      }
    }

    .confirm-btn {
      position: fixed;
      z-index: 2;
      bottom: 34px;
      left: 14px;
      width: calc(100vw - 28px);
      height: 42px;
      border-radius: 100px;
      font-size: 16px;
      text-align: center;
      line-height: 42px;
      font-weight: 500;
      color: #fff;
      background-color: #EB1700;
    }
  }
}

.radio2 {
  display: flex;
  justify-content: space-between;
  padding: 15px 0;
  margin: 0 14px;
  box-sizing: border-box;
  position: relative;
  min-height: 24px;

  &::before {
    position: absolute;
    box-sizing: border-box;
    content: " ";
    pointer-events: none;
    right: 0;
    top: 0;
    left: 0;
    border-bottom: 1px solid #ebedf0;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }

  &::after {
    position: absolute;
    box-sizing: border-box;
    content: " ";
    pointer-events: none;
    right: 0;
    bottom: 0;
    left: 0;
    border-bottom: 1px solid #ebedf0;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }

  .label-txt {
    font-size: 14px;
    color: #343434;
    line-height: 20px;
  }

  .con-txt {
    height: 200px;
    width: 200px;
    overflow-y: auto;
  }

  .txt-div {
    display: flex;
    align-items: center;
    margin-bottom: 15px;

    &:nth-last-child(1) {
      margin-bottom: 0;
    }

    .txt {
      color: #EB1700;
      font-size: 14px;
      white-space: nowrap;
      width: 180px;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .icon-txt {
      width: 16px;
      height: 16px;
      margin-left: 10px;
    }
  }
}

.model {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  background: rgba(0, 0, 0, 0.6);

  .model-data {
    width: 100%;
    box-sizing: border-box;
    height: 50vh;
    background: #fff;
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 10px 16px 20px;
    z-index: 2;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;
      background: url('../../assets/images/grade/mock-box-bg.png') no-repeat center center / 100% 100%;
      width: 100%;
      height: 63px;
    }

    .model-head {
      width: 100%;
      display: flex;
      font-size: 14px;
      font-weight: 400;
      position: relative;
      z-index: 3;

      .close {
        color: #000000;
      }

      .head-title {
        flex: 1;
        text-align: center;
        font-weight: 600;
        color: #000000;
      }

      .ok {
        color: #EB1700;
      }
    }

    .model-main {
      margin-top: 16px;

      .model-top {
        display: flex;
        align-items: center;

        .main-left {
          flex: 1;

          /deep/ .van-cell {
            height: 38px !important;
            border: 1px solid #AEAEAE;
            background: #F0F1F6;
            border-radius: 8px;
          }

          /deep/ .van-field__control {
            line-height: 18px !important;
            font-family: PingFang HK, PingFang HK;
            font-weight: 500;
            color: #AEAEAE;
          }
        }

        .hen {
          width: 6px;
          margin: 0 4px;

        }

        .main-right {
          flex: 1;

          /deep/ .van-cell {
            height: 38px !important;
            border: 1px solid #AEAEAE;
            background: #F0F1F6;
            border-radius: 8px;
          }

          /deep/ .van-field__control {
            line-height: 18px !important;
          }
        }

        .startTime {
          /deep/ .van-field__control {
            color: #000;
            font-weight: 600;

            &::placeholder {
              color: #000;
              font-weight: 600;
            }
          }
        }
      }

      .model-btm {
        margin-top: 20px;
      }
    }

    /deep/ .van-overlay {
      background: transparent !important;
    }

    /deep/ .van-popup,
    .van-picker {
      background: transparent !important;
    }

    /deep/ .van-popup {
      height: 45%;
    }

    /deep/ .van-picker__toolbar {
      display: none !important;
    }
  }
}</style>



// WEBPACK FOOTER //
// src/views/grade/gradeExamine.vue